<template>
	<div class="department-manage-root pa-1 d-flex flex-column">
		<div class="flex-grow-0 flex-shrink-0 d-flex mb-1">
			<v-btn ref="refreshButton" class="mr-1 round"
				color="primary"
				:dark="false"
				:disabled="refreshButtonDisabled()"
				@click="refreshButtonClicked()"
				>
				<v-icon>mdi-file-search-outline</v-icon>
				<span>刷新</span>
			</v-btn>

			<div class="mx-1" />

			<v-btn ref="addLowerLevelButton" class="mr-1 left-round"
				color="success"
				:disabled="addLowerLevelButtonDisabled()"
				@click="addLowerLevelButtonClicked()"
				>
				<v-icon>mdi-file-outline</v-icon>
				<span>增加下级</span>
			</v-btn>

			<v-btn ref="addSameLevelButton" class="mr-1"
				color="success"
				:disabled="addSameLevelButtonDisabled()"
				@click="addSameLevelButtonClicked()"
				>
				<v-icon>mdi-file-outline</v-icon>
				<span>增加同级</span>
			</v-btn>

			<v-btn ref="editButton" class="mr-1 right-round"
				color="success"
				:disabled="editButtonDisabled()"
				@click="editButtonClicked()"
				>
				<v-icon>mdi-notebook-edit-outline</v-icon>
				<span>编辑</span>
			</v-btn>

			<div class="mx-1" />

			<v-btn ref="stopButton" class="mr-1 round"
				color="warning"
				:dark="false"
				:disabled="stopButtonDisabled()"
				@click="stopButtonClicked()"
				>
				<v-icon>mdi-stop-circle-outline</v-icon>
				<span>停用</span>
			</v-btn>

		</div>
		<div class="flex-grow-1 flex-shrink-1" style="position:relative;">
            <div style="position:absolute;top:0;bottom:0;left:0;right:0;">				
				<v-data-table
					:headers="headers"
					fixed-header
					:items="visibleDepartments"		   
					class="elevation-1 department-table "
					disable-pagination
					hide-default-footer
					single-select 
					show-select
					height="100%"
					v-model="selectedDepartments"
				>
					
					<template v-slot:item.code="{ item }">
						<div>
							<span>
								<span v-for="n in item.level-1" v-bind:key="n">&#8195; &emsp;</span>
								<v-icon v-if="canOpen(item)" v-on:click="openDepartment(item)">mdi-plus-box-outline</v-icon>
								<v-icon v-else-if="canClose(item)"  v-on:click="closeDepartment(item)">mdi-minus-box-outline</v-icon>
								<v-icon v-else>mdi-border-none-variant</v-icon>
								{{ item.code}}
							</span>
						</div>
						<!--	
						<v-container>
						<v-row>
							<v-col>
								<span v-for="n in item.level-1" v-bind:key="n">&#8195; &emsp;</span>
								<v-icon v-if="canOpen(item)" v-on:click="openDepartment(item)">mdi-plus-box-outline</v-icon>
								<v-icon v-else-if="canClose(item)"  v-on:click="closeDepartment(item)">mdi-minus-box-outline</v-icon>
								<v-icon v-else>mdi-border-none-variant</v-icon>
								{{ item.code}}
							</v-col>					
						</v-row>
						
						</v-container>
						-->
					</template>
				</v-data-table>
			</div>
		</div>
		<DepartmentEditDialog 
			ref="departmentEditDialog"
            @persistDepartmentFinished="persistDepartmentFinished"
		/> 
	</div>
</template>

<script>
	import {default as DepartmentApi} from "../../../../api/smp/org/DepartmentApi.js";
	import DepartmentBill from "./DepartmentBill.js";
	import DepartmentEditDialog from "./DepartmentEditDialog.vue";
	import App  from "../../../../config/app.js";
	
	export default {
		name: 'Smp-Dept-Manage',
		components: {
			"DepartmentEditDialog":DepartmentEditDialog,
		},
		props:['page'],
		data: () => ({
			headers:[
				{text: '编号',align: 'start',sortable: false,value: 'code',width:400,divider:true},
				{ text: '名称', value: 'name',sortable: false ,width:300,divider:true},
				{ text: '状态', value: 'statusCaption',sortable: false ,width:100,divider:true},
				{ text: '营运部门', value: 'operationCaption',sortable: false ,width:100,divider:true},
				{ text: '末级部门', value: 'leafCaption',sortable: false ,width:100,divider:true},
				{ text: '默认部门', value: 'defaultCaption',sortable: false ,width:100,divider:true},
				{ text: '对应组织', value: 'orgName',sortable: false ,width:200,divider:true},
				{ text: '上级组织', value: 'parentOrgName',sortable: false ,width:200,divider:true},
				{ text: '创建时间', value: 'createTime',sortable: false ,width:180,divider:true},
				{ text: '修改时间', value: 'updateTime',sortable: false ,width:180,divider:true},
				{ text: '',value: '',sortable: false,divider: false},
				
			],
			departments:[],
			selectedDepartments:[],
			visibleDepartments:[],
			departmentBill:null,
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			refreshButtonClicked(){
				this.loadDepartments();
			},
			addLowerLevelButtonClicked(){
				if(!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1))
					return;
				let selectedDepartment = this.selectedDepartments[0];
				let dialog = this.$refs.departmentEditDialog;
				dialog.clear();
				dialog.setParentDepartment(selectedDepartment);
				dialog.setMode(1);
				dialog.refreshMode();
				dialog.setVisible(true);
			},
			addSameLevelButtonClicked(){
				if(!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1))
					return;
				let selectedDepartment = this.selectedDepartments[0];
				let dialog = this.$refs.departmentEditDialog;
				dialog.clear();
				dialog.setBrotherDepartment(selectedDepartment);
				dialog.setMode(2);
				dialog.refreshMode();
				dialog.setVisible(true);
			},
			persistDepartmentFinished(mode,department){
				let me = this;
				let codeLevelLength = App.DEPT_CODE_LEVEL_LENGTH;
				if(mode==1 || mode==2){
					if(department.code.length==codeLevelLength){
						this.departments.push(department);
						department.level = 1;
						me.collectVisibleDepartments();
					}else{
						let parentDepartmentCode = department.code.substr(0,department.code.length-1*codeLevelLength);
						let parentDepartment = this.searchDepartmentByCode(this.departments,parentDepartmentCode);
						if(parentDepartment){
							if(!parentDepartment.lower)
								parentDepartment.lower = [];
							parentDepartment.lower.push(department);
							department.higher = parentDepartment;
							department.level = parentDepartment.level+1;
							me.collectVisibleDepartments();
						}
					}
				}else if(mode==3 || mode==4){
					let oriDepartment = this.searchDepartmentByCode(this.departments,department.code);
					if(oriDepartment){
						this.simpleCopy(department,oriDepartment);
					}else{
						me.errMsg('错误','未找到部门信息,未更新前端部门显示');
					}
				}
			},
			searchDepartmentByCode(departments,code){
				let me = this;
				if(!departments)
					return null;
				for(var idx in departments){
					let department  = departments[idx];

					if(department && department.code && department.code==code){
							return department ;
					}

					if(department && department.code && department.code.length<code.length){
						if(department.code==code.substr(0,department.code.length))
							return me.searchDepartmentByCode(department.lower,code);
					}
				}
				return null;
			},
			editButtonClicked(){
				if(!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1))
					return;
				let selectedDepartment = this.selectedDepartments[0];
				let dialog = this.$refs.departmentEditDialog;
				dialog.clear();
				dialog.setEditingDepartment(selectedDepartment);
				dialog.setMode(3);
				dialog.refreshMode();
				dialog.setVisible(true);
			},
			stopButtonClicked(){
				if(!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1))
					return;
				let selectedDepartment = this.selectedDepartments[0];
				let dialog = this.$refs.departmentEditDialog;
				dialog.clear();
				dialog.setEditingDepartment(selectedDepartment);
				dialog.setMode(4);
				dialog.refreshMode();
				dialog.setVisible(true);
			},
			loadDepartments(){
				let me = this;
				DepartmentApi.queryAllDepartmentTree().then(function(resp){
					let data = resp.data;

					if((!data)||(!(data.code))||(data.code!=200)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取部门信息失败':msg;
						throw new Error(msg);
						return;
					}
					if((!data.data)||(!data.data.departments)){
						throw new Error('获取部门信息失败(无部门数据)');
						return;
					}
					
					let departments = data.data.departments;
					me.levelDepartments(departments,1,null);
					me.departments = departments;
					
					me.collectVisibleDepartments();
				}).catch(function(err){
					me.errMsg('错误','获取部门信息失败:'+err.message);
				});
			},
			levelDepartments(departments,level,higherDepartment){
				let me = this;
				
				departments.forEach(function(item){
					me.departments.push(item);
					item.higher = higherDepartment;
					item.level = level;
					item.opened = false;		
					if(item.lower)
						me.levelDepartments(item.lower,level+1,item);		
						
				});
			},
			canOpen(department){
				return this.hasLower(department)&&(!department.opened);
			},
			canClose(department){
				return this.hasLower(department)&&(department.opened);
			},
			hasLower(department){
				return department && department.lower && department.lower.length && department.lower.length>0 ;
			},
			openDepartment(department){
				department.opened = true;
				this.collectVisibleDepartments();
			},
			closeDepartment(department){
				department.opened = false;
				this.collectVisibleDepartments();
			},
			departmentVisible(department){
				//console.log("FILTERING");
				//console.log(department);
				if(!department.higher)
					return true;
				return department.higher.opened;	
			},
			collectVisibleDepartment(visible,depart){
				let me = this;
				if(this.departmentVisible(depart)){
					visible.push(depart);
					if(depart.lower){
						depart.lower.forEach(function(item){
							me.collectVisibleDepartment(visible,item);
						});
					}
				}
			},
			collectVisibleDepartments(){
				let visible = [];
				let me = this;
				me.departments.forEach(function(item){
					me.collectVisibleDepartment(visible,item);
				});
				//console.log("visibleDepartments");
				//console.log(visible);
				me.visibleDepartments=visible;
			},
			async loadModeInfo(){
				await this.departmentBill.loadModeInfo();
			},
			getModeHelper(){
				return this.departmentBill.getModeHelper();
			},
			getQueryButtonPermited(){
				let modeHelper = this.getModeHelper();
				return modeHelper && modeHelper.getQueryButtonPermited();
			},
			refreshButtonDisabled(){
                return (!this.getQueryButtonPermited());
			},
			getEditButtonPermited(){
				let modeHelper = this.getModeHelper();
				return modeHelper && modeHelper.getEditButtonPermited();
			},
			editButtonDisabled(){
                return (!this.getEditButtonPermited())
                || (!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1));
            },
			getAddLowerLevelButtonPermited(){
				let modeHelper = this.getModeHelper();
				return modeHelper && modeHelper.getAddLowLevelButtonPermited();
			},
            addLowerLevelButtonDisabled(){

				if(!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1))
					return true;
				let department = this.selectedDepartments[0];
				return (!this.getAddLowerLevelButtonPermited())
                || (!(department && department.leafFlag && department.leafFlag!='1'));
            },
			getAddSameLevelButtonPermited(){
				let modeHelper = this.getModeHelper();
				return modeHelper && modeHelper.getAddSameLevelButtonPermited();
			},
            addSameLevelButtonDisabled(){
				return (!this.getAddSameLevelButtonPermited())
                || (!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1));
            },
			getStopButtonPermited(){
				let modeHelper = this.getModeHelper();
				return modeHelper && modeHelper.getStopButtonPermited();
			},
            stopButtonDisabled(){
				return (!this.getStopButtonPermited())
                || (!(this.selectedDepartments && this.selectedDepartments.length && this.selectedDepartments.length==1));
			},
			simpleCopy(from,to){
                
                to.id = from.id;
                to.code = from.code;
                to.name = from.name;

                to.status = from.status;
                to.leafFlag = from.leafFlag;
                to.defaultFlag = from.defaultFlag;
                to.statusCaption = from.statusCaption;
                to.leafCaption = from.leafCaption;
                to.defaultCaption = from.defaultCaption;

                to.orgId = from.orgId;
                to.orgName = from.orgName;
                to.parentOrgId = from.parentOrgId;
                to.parentOrgName = from.parentOrgName;

                to.operationFlag = from.operationFlag;
                to.operationCaption = from.operationCaption;

                return to;
            },
		},
		computed:{		
		},
		created(){
			//this.loadDepartments();
			this.departmentBill = new DepartmentBill();
			this.departmentBill.setMenuId(this.page.id);
			this.loadModeInfo();
		}
	}
</script>

<style scoped>
	.department-manage-root{	
		height:100%;
		
	}
	.department-table{		
		height:100%; 
	}
</style>
